import React from "react";
import "./CardGrid.scss";
import useSessionVariables from "../components/useSessionVariables";
import { checkAccess } from "../utils/apiUtils";
import Card from "./Card.js";

function CardGrid({
  onTriggerAutomation,
  isAutomationLoading,
  reportUrl,
  onTriggerMisReport,
  isMisReportLoading,
  onTriggerLrReport,
  isLrReportLoading,
  lrReportUrl,
  onTriggerSoAutomation,
  isSoAutomationLoading,
  onTriggerMergeMis,
  isMergeMisLoading,
}) {
  const { sessionVariables } = useSessionVariables();
  
  const roleId = JSON.parse(window.sessionStorage.getItem("role_id"))?.role_id;
  const userId = JSON.parse(window.sessionStorage.getItem("user_id"))?.user_id;

  const dashboardInfo =
    JSON.parse(sessionStorage.getItem("dashboard_info"))?.dashboard_info ?? [];

  let gridItems = dashboardInfo.map((item) => ({
    label: item.menu_name,
    url: "/" + item.menu_accessor,
  }));

  let isBranchView = false;

  if (userId === 277) {
    isBranchView = true;
    const branchInfo =
      JSON.parse(sessionStorage.getItem("branch_info"))?.branch_info ?? [];
    gridItems = branchInfo.map((branch) => ({
      label: branch.branch_name,
      url: "/inward",
      branchId: branch.branch_id,
    }));
  }

  if (userId === 69 || userId === 45 || userId === 5 || userId === 287) {
    if (reportUrl) {
      gridItems.push({
        label: "View Report",
        url: reportUrl,
        isReport: true,
      });
    } else {
      gridItems.push({
        label: isAutomationLoading
          ? "Automation Processing..."
          : "Trigger Automation",
        url: "#automation",
        isAutomation: true,
      });
    }
  }

  if ([1, 74, 289].includes(userId)) {
    const consigneeStationMasterItem = {
      label: "Consignee Station Master",
      url: "/consignee_station_master",
      isModuleLink: true,
    };

    const alreadyAdded = gridItems.some(
      (gridItem) => gridItem.url === consigneeStationMasterItem.url
    );

    if (!alreadyAdded) {
      gridItems.push(consigneeStationMasterItem);
    }
  }

  if (userId === 285) {
    gridItems.push({
      label: isMisReportLoading
        ? "MIS Report Generating..."
        : "Generate MIS Report",
      url: "#mis-report",
      isMisReport: true,
    });

    if (lrReportUrl) {
      gridItems.push({
        label: "View Report",
        url: lrReportUrl,
        isReport: true,
      });
    } else {
      gridItems.push({
        label: isLrReportLoading
          ? "LR Automation Processing..."
          : "Trigger LR Automation",
        url: "#lr-automation",
        isLrReport: true,
      });
    }

    gridItems.push({
      label: isSoAutomationLoading
        ? "SO Automation Processing..."
        : "Trigger SO Automation",
      url: "#so-automation",
      isSoAutomation: true,
    });

    gridItems.push({
      label: isMergeMisLoading
        ? "Uploading..."
        : "Merge MIS Reports",
      url: "#merge-mis",
      isMergeMis: true,
    });
    
  }

  const filteredItems = [];
  let inc = 0;

  gridItems.forEach((gridItem) => {
      if (
      isBranchView ||
      gridItem.isModuleLink ||
      gridItem.isAutomation ||
      gridItem.isReport ||
      gridItem.isMisReport ||
      gridItem.isLrReport ||
      gridItem.isSoAutomation ||
      gridItem.isMergeMis
    ) {
      inc += 1;
      filteredItems.push({ ...gridItem, displayIndex: inc });
      return;
    }

    const module = gridItem.url.replace("/", "");
    const acc = checkAccess(module, sessionVariables);

    if (acc && !(roleId !== 1 && module === "report-bilty")) {
      inc += 1;
      filteredItems.push({ ...gridItem, displayIndex: inc });
    }
  });

  return (
    <div className="grid-container">
      {filteredItems.map((gridItem, index) => (
        <Card
          key={index}
          index={gridItem.displayIndex}
          item={gridItem}
          isBranch={isBranchView}
          onClick={() => {
            if (gridItem.isAutomation && onTriggerAutomation) {
              onTriggerAutomation();
            }

            if (gridItem.isMisReport && onTriggerMisReport) {
              onTriggerMisReport();
            }

            if (gridItem.isLrReport && onTriggerLrReport) {
              onTriggerLrReport();
            }

            if (gridItem.isSoAutomation && onTriggerSoAutomation) {
              onTriggerSoAutomation();
            }

            if (gridItem.isMergeMis && onTriggerMergeMis) {
              console.log("Merge MIS clicked");
              onTriggerMergeMis();
            }
          }}
          isLoading={
            (gridItem.isAutomation && isAutomationLoading) ||
            (gridItem.isMisReport && isMisReportLoading) ||
            (gridItem.isLrReport && isLrReportLoading) ||
            (gridItem.isSoAutomation && isSoAutomationLoading) ||
            (gridItem.isMergeMis && isMergeMisLoading)
          }
        />
      ))}
    </div>
  );
}

export default CardGrid;
